import React, { createContext, useContext } from 'react';

export const UserChat = createContext([]);

export function ChatProvider({ children }) {
  const removeChatSavedById = (id) => {
    const chatSavedJson = window.localStorage.getItem('chatsSaved');
    if (chatSavedJson) {
      const chatSaved = JSON.parse(chatSavedJson);
      if (chatSaved.length > 0) {
        const newChatsSaved = chatSaved.filter((chat) => chat.id !== id);
        window.localStorage.setItem(
          'chatsSaved',
          JSON.stringify(newChatsSaved)
        );
      }
    }
  };

  return (
    <>
      <UserChat.Provider value={{ removeChatSavedById }}>
        {children}
      </UserChat.Provider>
    </>
  );
}
export function useChat() {
  const context = useContext(UserChat);
  return context;
}
